import React from 'react';
import ObjectViewLayout from '@/components/layouts/ObjectViewLayout';
import { RelationshipCompanyTabView } from './RelationshipCompanyTabView';
import { RelationshipCompanyAboutCard } from './RelationshipCompanyAboutCard';

const RelationshipCompanyViewWrapper = () => (
	<ObjectViewLayout
		tabView={<RelationshipCompanyTabView />}
		aboutCard={<RelationshipCompanyAboutCard />}
	/>
);

RelationshipCompanyViewWrapper.displayName = 'RelationshipCompanyViewWrapper';

export default RelationshipCompanyViewWrapper;
